'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Video = function () {
    function Video(videos, duration) {
        var _this = this;
        _classCallCheck(this, Video);
        this.videos = videos;
        this.multi = this.videos.length > 1;
        this.index = 0;
        this.current = this.videos[this.index];
        this.duration = duration || 0;
        this.durationArr = [];
        this.eventAll = [];
        this.eventCurrent = [];
        this.on('all', 'durationchange', function (i, video) {
            if (video.duration !== 1) {
                _this.durationArr[i] = video.duration;
                if (!duration) {
                    _this.duration = _this.durationArr.reduce(function (sum, cur) {
                        return sum + cur;
                    });
                }
            }
        });
        this.on('current', 'end', function () {
            _this.switch(_this.index + 1);
        });
    }
    _createClass(Video, [
        {
            key: 'switch',
            value: function _switch(index, time) {
                if (this.index !== index) {
                    this.videos[index].classList.add('dplayer-video-current');
                    if (!this.current.paused) {
                        this.videos[index].play();
                    }
                    this.current.classList.remove('dplayer-video-current');
                    this.current.pause();
                    this.index = index;
                    this.current = this.videos[this.index];
                    this.videos[index].currentTime = time ? time : 0;
                } else {
                    this.videos[index].currentTime = time ? time : 0;
                }
            }
        },
        {
            key: 'on',
            value: function on(type, event, callback) {
                var _this2 = this;
                if (typeof callback === 'function') {
                    if (type === 'all') {
                        if (!this.eventAll[event]) {
                            this.eventAll[event] = [];
                        }
                        this.eventAll[event].push(callback);
                    } else {
                        if (!this.eventCurrent[event]) {
                            this.eventCurrent[event] = [];
                        }
                        this.eventCurrent[event].push(callback);
                    }
                    if (['seeking'].indexOf(event) === -1) {
                        var _loop = function _loop(i) {
                            _this2.videos[i].addEventListener(event, function () {
                                if (type === 'all' || _this2.videos[i] === _this2.current) {
                                    callback(i, _this2.videos[i]);
                                }
                            });
                        };
                        for (var i = 0; i < this.videos.length; i++) {
                            _loop(i);
                        }
                    }
                }
            }
        },
        {
            key: 'trigger',
            value: function trigger(type, event) {
                var events = type === 'all' ? this.eventAll : this.eventCurrent;
                if (events[event]) {
                    for (var i = 0; i < events[event].length; i++) {
                        events[event][i]();
                    }
                }
            }
        },
        {
            key: 'currentTime',
            value: function currentTime() {
                if (this.durationArr.slice(0, this.index).length) {
                    return this.durationArr.slice(0, this.index).reduce(function (sum, cur) {
                        return sum + cur;
                    }) + this.current.currentTime;
                } else {
                    return this.current.currentTime;
                }
            }
        },
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                time = Math.min(time, this.duration);
                var i = 0;
                var tmptime = 0;
                while (tmptime <= time) {
                    tmptime += this.durationArr[i];
                    i++;
                }
                var currentTime = void 0;
                if (this.durationArr.slice(0, this.index).length) {
                    currentTime = time - this.durationArr.slice(0, i - 1).reduce(function (sum, cur) {
                        return sum + cur;
                    });
                } else {
                    currentTime = time;
                }
                this.switch(i - 1, currentTime);
                this.trigger('all', 'seeking');
            }
        },
        {
            key: 'attr',
            value: function attr(option, value) {
                if (value !== undefined) {
                    for (var i = 0; i < this.videos.length; i++) {
                        this.videos[i][option] = value;
                    }
                }
                return this.current[option];
            }
        },
        {
            key: 'play',
            value: function play() {
                this.current.play();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.current.pause();
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                this.current.paused ? this.play() : this.pause();
            }
        }
    ]);
    return Video;
}();
module.exports = Video;


//////////////////
// WEBPACK FOOTER
// ./src/video.js
// module id = 8
// module chunks = 0